import React from "react";
import '../css/Habilidades.css'

export default function Habilidade(){
    return(
        <section id="habilidades">
            <div className="containerHabilidades">
                <h1 className="titleH">Habilidades</h1>
                <div className="group">
                    <aside className="programacao">
                        <p className="subtitleH">Programação</p>
                        <div className="containerProgramacao">
                            <p>Front End</p>
                            <p>* HTML: estudando</p>
                            <p>* CSS: estudando</p>
                            <p>* JAVASCRIPT: estudando</p>
                            <p>* REACT: estudando</p>
                            <div id="backend">
                                <p>Back End</p>
                                <p>* Python</p>
                            </div>
                        </div>
                    </aside>
                    
                    <aside className="cursos">
                        <p className="subtitleH">Cursos</p>
                        <div className="containerCursos">
                            <p>Design Gráfico - 97 horas - Edune (MS)</p>
                            <p>Técnico em Informática - 160 horas - IFRO (RO)</p>
                        </div>
                    </aside>
                </div>
            </div>
        </section>
    );

}